import*as e from"react";const t=e.createContext("inactive"),r=({value:r,children:a})=>e.createElement(t.Provider,{value:r},a);export{t as DropZoneContext,r as DropZoneProvider};
